var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSensorEmgIcon = function SvgSensorEmgIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 14,
    height: 14
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.25 3.75a2.5 2.5 0 0 1 2.425 3.111c2.476 1.66 4.279 4.092 5.292 7.139h-1.324c-.931-2.562-2.481-4.607-4.572-6.038A2.5 2.5 0 1 1 6.25 3.75Zm0-3.75a6.25 6.25 0 0 1 5.958 8.144c-.293-.333-.6-.65-.92-.952a5.125 5.125 0 1 0-2.28 3.378c.257.275.499.564.726.868A6.25 6.25 0 1 1 6.25 0Zm.945 7.068.066-.082.107-.177.071-.173.035-.135.014-.079.01-.088.002-.084a1.25 1.25 0 1 0-.305.818Z",
    fill: "#000"
  }))));
};

export default SvgSensorEmgIcon;